import styled from '@emotion/styled';

const Fourth:React.FC<any> = () => {
  return (
    <Container>
      <BodyImgContainer>
        <Img src="/images/newLanding/landingApp/368722032.png"/>
      </BodyImgContainer>
      <TextContainer>
        <Text1>
          <span>클릭 한번에 양가부모님께,&nbsp; </span> 선물하세요
        </Text1>
        <SmallText>
          손주사진은
          <br/>부모님께 최고의 선물이니까요
        </SmallText>
      </TextContainer>
    </Container>
  )
};

export default Fourth;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f0Ede7;
`;

const BodyImgContainer = styled.div`
  width: 100%;
  margin: 70px auto 40px;
`;

const Img = styled.img`
  width: 100%;
`;


const Text1 = styled.div`
  font-size: 20px;
  display: flex;
  margin: 40px auto 0px;

  span {
    font-weight: 600;
  }
`;

const TextContainer = styled.div`
  width: 100%;
  background-color: #f0Ede7;
  display: flex;
  flex-direction: column;
`


const SmallText = styled.div`
  font-size: 14px;
  margin: 30px auto 140px;
  text-align: center;
`